<template>
  <Alert
    class="sync-licenses-alert"
    :prominent="!$vuetify.breakpoint.mobile"
    color="info"
    icon="ph-fill ph-hourglass-high"
    outlined
  >
    <p v-html="$t('licensing.synchronizingLicenses')"></p>
    <v-progress-linear
      color="#2C58A0"
      class="my-5 white--text"
      indeterminate
      height="15"
      rounded
    >
    </v-progress-linear>
  </Alert>
</template>

<script>
import Alert from "@/components/base/Alert.vue";

export default {
  name: "SyncLicensesAlert",
  components: {
    Alert,
  },
};
</script>

<style scoped>
.sync-licenses-alert >>> .v-icon {
  color: #2c58a0 !important;
}
</style>
